import React, { useState } from "react";

import "./stylesCollectionsPopup.css";
import { X } from "react-feather";
import SaveButton from "../../CommonComponents/SaveButton/SaveButton";
import { message } from "antd";

function CollectionsPopup({ isVisible, onClosePressed, getEventCodesList }) {
  const [comment, setComment] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const maxChars = 50;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!comment.trim()) {
      messageApi.error("Please enter a category name");

      return;
    }

    setIsSubmitting(true);
    try {
      await getEventCodesList({
        name: comment,
        etype: "collection",
      });

      handleClosePressed();
    } catch (error) {
      console.error("Error submitting category:", error);
      messageApi.error("Failed to submit category. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClosePressed = () => {
    onClosePressed();
    setComment("");
  };

  const handleSetComment = (value) => {
    if (value.length <= maxChars) {
      setComment(value);
    }
  };

  if (!isVisible) return null;
  return (
    <div className="location-restrictions-popup">
      {contextHolder}
      <div className="location-restrictions-panel">
        <div className="location-restrictions-panel-header">
          <h2>New Collection</h2>
          <button className="close-button" onClick={handleClosePressed}>
            <X className="close-icon" />
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="event-code-input">
            <label htmlFor="eventCode">Name</label>
            <textarea
              id="eventCode"
              value={comment}
              placeholder="Collection Name"
              onChange={(e) => handleSetComment(e.target.value)}
              rows="1"
              required
            />
            <div className="comment-counter">
              {comment.length}/{maxChars}
            </div>
          </div>
          <SaveButton
            isSubmitting={isSubmitting}
            buttonText="Add Collection"
            cancelButton={true}
            cancelButtonText="No"
            callbackFunction={handleSubmit}
            callbackFunctionCancel={handleClosePressed}
          />
        </form>
      </div>
    </div>
  );
}

export default CollectionsPopup;
